// extracted by mini-css-extract-plugin
export default {"contents":"aE-z","sectionHeading":"bE-z"};